module.exports = __webpack_public_path__ + "img/await.1df25ab6.png";